import { ScrollReveal } from './ScrollReveal';
import ParticleField from './ParticleField';
import AurocleLogo from './AurocleLogo';
import { useLang } from '@/lib/translations';

const HERO_IMG = 'https://static.prod-images.emergentagent.com/jobs/cf608264-414a-47a4-aa49-755218a60bb9/images/f6312dca0e15089b8f04e18d28d03a7c2fb48247389a8dfcd0869a9498c0879f.png';

const FOCUSES = ['Executive', 'Sales', 'Operations', 'Legal', 'Finance', 'Research', 'Private Office', 'Multi-Team'];

export default function HeroSection() {
  const { t } = useLang();
  const h = t.hero;
  return (
    <section id="overview" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" loading="eager" />
        <div className="absolute inset-0 bg-gradient-to-b from-aurocle-base/30 via-aurocle-base/70 to-aurocle-base" />
      </div>

      <div className="absolute top-1/4 left-1/6 w-[500px] h-[500px] bg-aurocle-gold/8 rounded-full blur-[160px] animate-glow-pulse pointer-events-none" />
      <div className="absolute bottom-1/3 right-1/5 w-[350px] h-[350px] bg-aurocle-gold/5 rounded-full blur-[120px] animate-glow-pulse-delay pointer-events-none" />

      <div className="absolute inset-0 grid-bg pointer-events-none" />

      <ParticleField />

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center pt-24">
        <ScrollReveal>
          <div className="flex items-center justify-center gap-3 mb-8">
            <AurocleLogo size={40} />
            <div className="overline">{h.badge}</div>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={100}>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-7xl tracking-tighter font-medium text-aurocle-text mb-6 leading-[1.05]">
            {h.h1_1}{' '}
            <br className="hidden sm:block" />
            {h.h1_2}<span className="font-accent italic text-aurocle-gold">{h.h1_accent}</span>
          </h1>
        </ScrollReveal>

        <ScrollReveal delay={200}>
          <p className="text-base sm:text-lg text-aurocle-platinum-muted max-w-3xl mx-auto mb-12 leading-relaxed font-body">
            {h.sub}
          </p>
        </ScrollReveal>

        <ScrollReveal delay={300}>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
            <a href="#contact" className="btn-gold cta-burning" data-testid="hero-request-demo-btn">
              {h.cta1}
            </a>
            <a href="#contact" className="btn-outline cta-outline-glow" data-testid="hero-book-meeting-btn">
              {h.cta2}
            </a>
          </div>
          <a href="#contact" className="btn-ghost text-xs" data-testid="hero-design-workforce-btn">
            {h.cta3}
          </a>
        </ScrollReveal>

        <ScrollReveal delay={400}>
          <p className="text-xs text-aurocle-platinum-muted/60 tracking-wider mt-8 font-mono">
            {h.trust}
          </p>
        </ScrollReveal>

        <ScrollReveal delay={500}>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-2">
            {FOCUSES.map((f) => (
              <a
                key={f}
                href="#capabilities"
                className="px-4 py-1.5 text-xs font-mono tracking-wider text-aurocle-text-secondary border border-white/8 hover:border-aurocle-gold/30 hover:text-aurocle-gold transition-all"
                data-testid={`hero-focus-${f.toLowerCase().replace(/\s/g, '-')}`}
              >
                {f}
              </a>
            ))}
          </div>
        </ScrollReveal>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-aurocle-base to-transparent pointer-events-none" />
    </section>
  );
}
